import React from 'react';
import { Notification } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const SuccessBA = () => {
  const {
    BUSINESS_APP_ORDERS: { successPage }
  } = useLocalizedStringsContext();

  return (
    <>
      <div className="container 85%" style={{ minHeight: '600px' }}>
        <Notification variant={{ style: 'success' }}>
          {successPage}
        </Notification>
      </div>
    </>
  );
};

export default SuccessBA;
